import { User } from '@xq/domain';

const createdAt = new Date().toISOString();
const modifiedAt = new Date().toISOString();

export const teachers: Partial<User>[] = [
  {
    createdAt,
    modifiedAt,
    classroomIds: [],
    displayName: '',
    email: 'e2e_test_teacher@xqlabsdev.io',
    uid: '',
    photoUrl:
      'https://lh3.googleusercontent.com/a/AATXAJyaU5cEL_0LJL7GZSDg33W-R0KEb2O9ZEi8H3XG=s96-c',
  },
  {
    createdAt,
    modifiedAt,
    classroomIds: [],
    displayName: '',
    email: 'stage.teacher.1@xqlabs.io',
    uid: '',
    photoUrl:
      'https://lh3.googleusercontent.com/a/AATXAJyaU5cEL_0LJL7GZSDg33W-R0KEb2O9ZEi8H3XG=s96-c',
  },
  {
    createdAt,
    modifiedAt,
    classroomIds: [],
    displayName: '',
    email: 'deyan.teacher@xqlabs.io',
    uid: '',
    photoUrl:
      'https://lh3.googleusercontent.com/a/AATXAJyaU5cEL_0LJL7GZSDg33W-R0KEb2O9ZEi8H3XG=s96-c',
  },
];

const testTeacherEmails = [
  'e2e_test_teacher@xqlabsdev.io',
  'stage.teacher.1@xqlabs.io',
  'deyan.teacher@xqlabs.io',
] as const;

export type TestTeacherEmail = (typeof testTeacherEmails)[number];

export const TEST_TEACHER_EMAILS = testTeacherEmails.reduce(
  (acc, email) => ({
    ...acc,
    [email]: email,
  }),
  {} as Record<TestTeacherEmail, TestTeacherEmail>
);

// TODO - ADD
// stage.teacher.2@xqlabs.io stage.teacher.3@xqlabs.io
